import { Select } from "@mantine/core";

type IPriceListReportTypeSelectProps = {
  value: number;
  name: string;
  label: string;
  title?: string;
  setValue: (val: number) => void;
};
const reportTypeOptions = [
  { value: "0", label: "--All--" },
  { value: "1", label: "Retail" },
  { value: "2", label: "Sell Price #1" },
  { value: "3", label: "Sell Price #2" },
];

const PriceListReportTypeSelect = ({
  value,
  label,
  title,
  name,
  setValue,
  ...rest
}: IPriceListReportTypeSelectProps) => {
  return (
    <Select
      name={name}
      key={name}
      label={label}
      data={reportTypeOptions}
      value={value.toString()}
      onChange={(val) => {
        const parsed = parseInt(val ?? "0", 10);
        setValue(parsed);
      }}
      allowDeselect={false}
      comboboxProps={{
        withinPortal: true,
        zIndex: 3001,
      }}
      clearable
    />
  );
};

export default PriceListReportTypeSelect;
